<template>
  <div>
    <profile/>
    <!-- <titleAgency/>
    <filterAgency class="my-0" />
    <tableAgency class="px-5" /> -->
  </div>
</template>

<script>
// import titleAgency from '@/components/_manageprofile/_overview/title.vue'
// import filterAgency from '@/components/_manageprofile/_overview/filter.vue'
// import tableAgency from '@/components/_manageprofile/_overview/table.vue'
import profile from '@/components/_manageprofile/_overview/profile.vue'
export default {
  components: {
    // titleAgency,
    // filterAgency,
    // tableAgency,
    profile
  }
}
</script>

<style scoped>
</style>
